import DownloadPaymentStatusReportRequestModelBase from '../_generated/modelBases/download-payment-status-report-request-model-base';

export default class DownloadPaymentStatusReportRequestModel extends DownloadPaymentStatusReportRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
